import PropTypes from "prop-types";
import React from "react";

import {AppData, Destination} from "v2/api/Records";
import {
  CancelIcon,
  FirstMaiVisitIcon,
  RevisitIcon,
} from "v2/components/icons";

const DestinationTitle = (props, context) => {
  const {
    className,
    data: {cancelReason, house, isFirstMaiVisit, isRevisit, title},
    sidebar,
    style,
  } = props;

  const {
    appData,
  } = context;

  let firstMaiVisitIcon;
  if (isFirstMaiVisit && !sidebar) {
    firstMaiVisitIcon = <FirstMaiVisitIcon />;
  }

  let isRevisitIcon;
  if (isRevisit && !sidebar) {
    isRevisitIcon = <RevisitIcon />;
  }

  let isCanceledIcon;
  if (cancelReason && !sidebar) {
    const cancelMessage = `Cancelled, ${appData.cancelReason.get(cancelReason)}`;
    isCanceledIcon = <CancelIcon title={cancelMessage} />;
  }

  return (
    <strong className={className} style={style}>
      {firstMaiVisitIcon}
      {isRevisitIcon}
      {isCanceledIcon}
      {house ? house.customer.fullName : title}
      {house && !sidebar && (
        <small className="erg-margin-left-15 text-muted" style={{fontWeight: "normal"}}>
          ID: {house.id}
        </small>
      )}
    </strong>
    );
};

DestinationTitle.contextTypes = {
  appData: PropTypes.instanceOf(AppData),
};
DestinationTitle.defaultProps = {
  sidebar: false,
  style: {},
};
DestinationTitle.propTypes = {
  className: PropTypes.string,
  data: PropTypes.instanceOf(Destination).isRequired,
  sidebar: PropTypes.bool,
  style: PropTypes.object,
};

export default DestinationTitle;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/DestinationTitle.js
 **/